import { Routes, Route } from 'react-router-dom';

import { paths } from 'data/routes';
import { useColumns } from 'data/tableData/catalogue/productsColumns';

import { productData } from 'data/mockData/products.mock';

import { Manage } from 'sections/Manage';

import { Table } from 'components/Table';

import { tabs } from './tabs.data';

export function Products(): React.ReactElement {
  const productsColumns = useColumns();

  return (
    <Routes>
      <Route path="/">
        <Route index element={<Table columns={productsColumns} data={productData} />} />

        <Route path={paths.manage} element={<Manage title="Products" tabs={tabs} />} />
      </Route>
    </Routes>
  );
}
